import {makeStyles} from "@material-ui/core";
import {Colors} from "../../styles/Colors";

export const useStyles = makeStyles(() => ({
    mainDashboardContainer: {
        width: '100%',
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        background: Colors.White,
        overflow: 'hidden',
        position: 'relative',
    },
    scrollable: {
        overflowY: 'auto',
        flex: 1,
        padding: '50px 90px 120px 90px',
    },
    totalCount: {
        marginTop: 8,
        fontSize: 14,
        color: Colors.Text3,
        fontWeight: 400,
        textTransform: 'capitalize',
        fontStyle: 'normal',
        lineHeight: 'normal',
    },
    loader: {
        display: 'flex',
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
    },
    header: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: 'calc(100% - 54px - 54px)',
        padding: '24px 96px',
    },
    rightSection: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    },
    voicemailListContainer: {
        backgroundColor: Colors.SmokeBackground,
    },
}));
